import { toast as sonnerToast } from 'sonner';

type ToastProps = {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive' | 'success';
  duration?: number;
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'top-center' | 'bottom-center';
};

export function useToast() {
  const toast = ({ title, description, variant = 'default', ...props }: ToastProps) => {
    // Create a simple toast with title and description
    if (title && description) {
      return sonnerToast(title, {
        description,
        ...props,
      });
    }

    // Create a toast with just title
    if (title) {
      return sonnerToast(title, props);
    }

    // Create a toast with just description
    if (description) {
      return sonnerToast(description, props);
    }
  };

  return { toast };
}
